// Traditional Chinese (Taiwan)
export const zhTW = {
  'nav.solutions': '直播解決方案',
  'nav.streamTemplates': '直播範本',
  "nav.prepare": "準備",
  "nav.events": "活動與直播",
  "nav.featurePresets": "功能預設",
  "nav.interact": "互動",
  "nav.boards": "互動白板",
  "nav.measure": "報告與商務",
  "nav.menu": "開啟導覽",
  "nav.closeMenu": "關閉導覽",

  'app.name':           'Kardolive',
  'app.tagline':        '客戶入口網站',
  'app.signOut':        '登出',

  'login.email':        '電子郵件',
  'login.password':     '密碼',
  'login.signIn':       '登入',
  'login.signingIn':    '正在登入…',
  'login.failed':       '登入失敗',
  'login.newAccount':   '初次使用 Kardolive?',
  'login.createAccount':'建立免費帳號 →',

  'nav.workspace':      '工作空間',
  'nav.templates':      '範本',
  'nav.live':           '直播',
  'nav.rooms':          '房間與聊天',
  'nav.content':        '內容',
  'nav.developer':      '開發者',
  'nav.account':        '帳號',

  'nav.overview':       '概覽',
  'nav.projects':       '專案',
  'nav.chat':           '聊天控制台',
  'nav.sessions':       '會話',
  'nav.streams':        '直播',
  'nav.studio':         '工作室',
  'nav.recordings':     '錄影',
  'nav.apiKeys':        'API 金鑰',
  'nav.webhooks':       'Webhook',
  'nav.webhookTester':  'Webhook 測試器',
  'nav.networkTest':    '網路測試',
  'nav.embed':          '嵌入小工具',
  'nav.sdk':            'SDK 與文件',
  'nav.docs':           '開發者文件',
  'nav.analytics':      '分析',
  'nav.settings':       '設定',

  'overview.welcome':       '歡迎回來,{name}',
  'overview.plan':          '{tenant} · {plan} 方案',
  'overview.newStream':     '新增直播',
  'overview.kpi.live':           '目前直播中',
  'overview.kpi.live.broadcasting': '場直播進行中',
  'overview.kpi.live.nothing':    '目前無直播',
  'overview.kpi.total':           '直播總數',
  'overview.kpi.total.sub':       '所有時段',
  'overview.kpi.sessions':        '工作階段 · 近30天',
  'overview.kpi.sessions.sub':    '發布事件',
  'overview.kpi.recordings':      '錄影',
  'overview.kpi.recordings.sub':  '可播放',
  'overview.recentStreams':       '最近的直播',
  'overview.recentSessions':      '最近的工作階段',
  'overview.viewAll':             '查看全部 →',
  'overview.empty.title':         '尚無直播',
  'overview.empty.body':          '建立您的第一個直播以開始推流。',
  'overview.empty.action':        '建立直播',
  'overview.noSessions':          '尚無工作階段',

  'status.live':        '直播中',
  'status.idle':        '閒置',
  'status.ended':       '已結束',
  'status.archived':    '已封存',

  'common.save':        '儲存',
  'common.cancel':      '取消',
  'common.delete':      '刪除',
  'common.edit':        '編輯',
  'common.create':      '建立',
  'common.confirm':     '確認',
  'common.loading':     '載入中…',
  'common.error':       '錯誤',
  'common.retry':       '重試',

  // Dashboard navigation and account controls.
  "nav.skipContent": "跳至頁面內容",
  "nav.scenarios": "應用情境",
  "nav.premieres": "首播",
  "nav.clips": "片段",
  "dashboard.account": "帳戶",
  "dashboard.language": "語言",
  "dashboard.appearance": "外觀",
  "nav.allStreams": "所有直播",
  "nav.destinations": "轉播目標",
  "nav.ecommerce": "電子商務",
  "nav.products": "商品",
  "nav.services": "服務",
  "nav.collections": "商品系列",
  "nav.orders": "訂單",
  "nav.commerceSettings": "商務設定",
  "nav.engagement": "互動",
  "theme.light": "切換至淺色模式",
  "theme.dark": "切換至深色模式",
  "role.owner": "擁有者",
  "role.admin": "管理員",
  "role.member": "成員",
  "role.viewer": "檢視者",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "使用中",
  "streams.archived": "已封存",
  "streams.monitor": "訊號監測",
  "streams.create": "建立直播",
  "streams.list": "清單",
  "streams.grid": "網格",
  "streams.view": "直播檢視",
  "streams.searchLabel": "搜尋活動",
  "streams.searchHint": "搜尋活動名稱",
  "streams.solutionFilter": "依直播類型篩選活動",
  "streams.statusFilter": "依狀態篩選活動",
  "streams.dateFilter": "依建立日期篩選活動",
  "streams.allSolutions": "所有直播類型",
  "streams.custom": "現有或自訂設定",
  "streams.allStatuses": "所有狀態",
  "streams.anyTime": "不限建立時間",
  "streams.last7": "最近 7 天建立",
  "streams.last30": "最近 30 天建立",
  "streams.count": "顯示 {shown} 個活動，共 {total} 個",
  "streams.noMatch": "沒有符合篩選條件的活動。",
  "streams.clearFilters": "清除篩選",
  "streams.refreshFailed": "無法重新整理直播清單",
  "streams.loadFailed": "無法載入直播",
  "streams.stale": "目前顯示上次載入的清單，直播狀態可能已變更。",
  "streams.connectionHint": "請檢查網路連線，然後重新載入清單。",
  "streams.retrying": "正在重試…",
  "streams.retry": "重試",
  "streams.restoreFailed": "無法還原直播",
  "streams.restoreHint": "請檢查網路連線並重新整理清單，確認最新狀態後再試。",
  "streams.unused": "未使用的直播：{count}",
  "streams.unusedHint": "這些直播沒有開播紀錄或重播。封存可整理清單，不會刪除內容。",
  "streams.reviewArchive": "查看並封存",
  "streams.loading": "正在載入直播…",
  "streams.archiveEmpty": "尚無封存。已封存的直播及重播會保留在此，直到還原。",
  "streams.restore": "還原",
  "streams.firstTitle": "建立您的第一個直播",
  "streams.firstBody": "選擇銷售、教學或服務設定，也可從空白直播開始。支援從瀏覽器、手機或 OBS 開播。",
  "streams.blank": "空白直播",
  "streams.broadcasts": "開播次數：{count}",
  "streams.replays": "重播：{count}",
  "streams.sessions": "工作階段：{count}",
  "streams.recordings": "錄製：{count}",
  "streams.mode.BROADCAST": "廣播",
  "streams.mode.LOW_LATENCY": "低延遲",
  "streams.mode.REALTIME": "即時",
  "streams.key": "金鑰",
  "streams.archiveTitle": "封存未使用的直播",
  "streams.archiveHint": "這些直播從未開播。您可以隨時從「已封存」分頁還原。",
  "streams.archiveFailed": "有 {count} 個直播無法封存，可能已經開播。其餘直播已封存。",
  "streams.archiving": "正在封存…",
  "streams.archiveCount": "封存 {count} 個",
  "streamType.webinar": "商務研討會與發表會",
  "streamType.classroom": "課堂與輔導",
  "streamType.training": "企業培訓",
  "streamType.conference": "會議與展覽",
  "streamType.shopping": "直播購物",
  "streamType.auction": "直播拍賣",
  "streamType.consultation": "私人諮詢",
  "streamType.creator": "創作者與社群直播",
  "streamType.audio": "語音房與 Podcast",
  "streamType.sports": "體育與電競",
  "streamType.performance": "音樂會與表演",
  "streamType.community": "宗教活動與募款",
  "streamType.tour": "導覽與示範",
  "streamType.fitness": "健身與工作坊",
  "streamType.public-meeting": "新聞與公共會議",
  "streamType.continuous": "持續頻道與攝影機",
  "streams.close": "關閉",
};
